import React from 'react';
import { View } from '@react-pdf/renderer';
import CardItem from './CardItem';
import Header from './Header';
import SelectionsLabel from './SelectionsLabel';
const SelectedItemsPage = ({ selectedItemsList, isVariant, }) => (React.createElement(View, null,
    React.createElement(Header, null),
    React.createElement(SelectionsLabel, null), selectedItemsList === null || selectedItemsList === void 0 ? void 0 :
    selectedItemsList.map(item => (React.createElement(CardItem, { item: item, key: item.id, isVariant: isVariant })))));
export default SelectedItemsPage;
